/**
 * Parses and cleans internal redirect URLs by removing the base URL prefix
 * @param {string} url - The URL to parse
 * @returns {string} - The cleaned URL
 */
export function parseInternalRedirect(url) {
    if (!url) return url

    const { nuxtBaseUrl } = useApplicationConstants()

    if (url === nuxtBaseUrl) {
        return '/'
    }

    while (url && url.startsWith(nuxtBaseUrl) && url.length > nuxtBaseUrl.length) {
        url = url.slice(nuxtBaseUrl.length)
    }

    // Ensure base-root redirects (/bp?foo, /bp#hash) stay absolute
    if (url.startsWith('?') || url.startsWith('#')) {
        return '/' + url
    }

    return url
}
